// ABOUTME: Primary button that toggles the request body sent to a shipper, shown next to shipper errors.
// ABOUTME: Renders the payload as formatted JSON with a copy button so support can paste it elsewhere.
import { Box, useTheme } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../theme";
import Shbutton from "./buttons/Shbutton";
import ShCopyButton from "./ShCopy";

const ShPayloadToggle = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    if (props.payload === null || props.payload === undefined) {
        return null;
    }

    const payloadText = typeof props.payload === "string" ? props.payload : JSON.stringify(props.payload, null, 2);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                ...props.sx
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: props.align === "right" ? "flex-end" : "flex-start",
                }}
            >
                <Shbutton
                    className={"s32"}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained"
                    startIcon={<InfoOutlinedIcon />}
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen(!open);
                    }}
                >
                    {t("show_label_request")}
                </Shbutton>
            </Box>
            {open &&
                <Box
                    sx={{
                        position: "relative",
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        borderRadius: 3,
                        p: 2,
                        pr: 7,
                    }}
                >
                    <Box
                        component="pre"
                        sx={{
                            m: 0,
                            fontSize: 12,
                            fontFamily: "monospace",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-all",
                            color: colors.txt["primary"],
                        }}
                    >
                        {payloadText}
                    </Box>
                    <ShCopyButton
                        sx={{ position: "absolute", top: 8, right: 8 }}
                        closeAfter={1500}
                        value={payloadText}
                    />
                </Box>
            }
        </Box>
    );
};

export default ShPayloadToggle;
